var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"manual":true,"effect":"light","content":"Ссылка скопирована!","placement":"top"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('button',{staticClass:"copy-link-btn btn btn-warning mt-0 float-left",on:{"click":_vm.copyLink}},[_c('font-awesome-icon',{attrs:{"icon":"link"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }